/**
 * AUTO-GENERATED by scripts/generate-landing-results.ts — do not hand-edit.
 *
 * Every graded NBA pick from prod bet_results, 2026-04-17 → 2026-06-13, graded at the
 * posted price, flat 1 unit, at two moments: as published (last_projection_update) and
 * 30 minutes before tip (30_min_before). `tiers` = the as-published view.
 * roi / winRate / avgEv / clv / beatClose are fractions; clv + beatClose cover only
 * picks with a ≥3-book closing consensus (clvSample).
 */

export interface ResultsTier {
  label: string;
  minEv: number;
  picks: number;
  wins: number;
  losses: number;
  pushes: number;
  units: number;
  roi: number;
  winRate: number;
  avgEv: number;
  clv: number | null;
  beatClose: number | null;
  clvSample: number;
  winningDays: number;
  days: number;
  curve: { date: string; units: number }[];
}

export interface ResultsSnapshot {
  label: string;
  moment: string;
  tiers: Record<'edge10' | 'all', ResultsTier>;
}

const SNAPSHOTS: Record<'lpu' | 'min30', ResultsSnapshot> = {
  "lpu": {
    "label": "When published",
    "moment": "when projections last updated before tip",
    "tiers": {
      "edge10": {
        "label": "10%+ edges",
        "minEv": 0.1,
        "picks": 819,
        "wins": 451,
        "losses": 366,
        "pushes": 2,
        "units": 59.06,
        "roi": 0.0721,
        "winRate": 0.552,
        "avgEv": 0.1494,
        "clv": 0.0232,
        "beatClose": 0.602,
        "clvSample": 716,
        "winningDays": 28,
        "days": 45,
        "curve": [
          {
            "date": "2026-04-17",
            "units": 1
          },
          {
            "date": "2026-04-18",
            "units": 14.55
          },
          {
            "date": "2026-04-19",
            "units": 26.99
          },
          {
            "date": "2026-04-20",
            "units": 29.87
          },
          {
            "date": "2026-04-21",
            "units": 37.08
          },
          {
            "date": "2026-04-22",
            "units": 43.59
          },
          {
            "date": "2026-04-23",
            "units": 48.35
          },
          {
            "date": "2026-04-24",
            "units": 53.22
          },
          {
            "date": "2026-04-25",
            "units": 58.11
          },
          {
            "date": "2026-04-26",
            "units": 49.39
          },
          {
            "date": "2026-04-27",
            "units": 48.31
          },
          {
            "date": "2026-04-28",
            "units": 51.55
          },
          {
            "date": "2026-04-29",
            "units": 48.76
          },
          {
            "date": "2026-04-30",
            "units": 52.07
          },
          {
            "date": "2026-05-01",
            "units": 52.09
          },
          {
            "date": "2026-05-02",
            "units": 41.11
          },
          {
            "date": "2026-05-03",
            "units": 35.94
          },
          {
            "date": "2026-05-04",
            "units": 43.1
          },
          {
            "date": "2026-05-05",
            "units": 40.69
          },
          {
            "date": "2026-05-06",
            "units": 51.4
          },
          {
            "date": "2026-05-07",
            "units": 46.5
          },
          {
            "date": "2026-05-08",
            "units": 43.44
          },
          {
            "date": "2026-05-09",
            "units": 38.94
          },
          {
            "date": "2026-05-10",
            "units": 39.72
          },
          {
            "date": "2026-05-11",
            "units": 40.5
          },
          {
            "date": "2026-05-12",
            "units": 41.59
          },
          {
            "date": "2026-05-13",
            "units": 37.88
          },
          {
            "date": "2026-05-15",
            "units": 43.24
          },
          {
            "date": "2026-05-17",
            "units": 39.93
          },
          {
            "date": "2026-05-18",
            "units": 39.14
          },
          {
            "date": "2026-05-19",
            "units": 42.32
          },
          {
            "date": "2026-05-20",
            "units": 44.25
          },
          {
            "date": "2026-05-21",
            "units": 45.28
          },
          {
            "date": "2026-05-22",
            "units": 39.15
          },
          {
            "date": "2026-05-23",
            "units": 39.47
          },
          {
            "date": "2026-05-24",
            "units": 49.08
          },
          {
            "date": "2026-05-25",
            "units": 53.42
          },
          {
            "date": "2026-05-26",
            "units": 47.63
          },
          {
            "date": "2026-05-28",
            "units": 53.25
          },
          {
            "date": "2026-05-30",
            "units": 56.25
          },
          {
            "date": "2026-06-03",
            "units": 56.25
          },
          {
            "date": "2026-06-05",
            "units": 57.55
          },
          {
            "date": "2026-06-08",
            "units": 57.26
          },
          {
            "date": "2026-06-10",
            "units": 59.99
          },
          {
            "date": "2026-06-13",
            "units": 59.06
          }
        ]
      },
      "all": {
        "label": "All +EV",
        "minEv": 0,
        "picks": 7607,
        "wins": 4041,
        "losses": 3542,
        "pushes": 24,
        "units": 150.95,
        "roi": 0.0198,
        "winRate": 0.5329,
        "avgEv": 0.0501,
        "clv": -0.011,
        "beatClose": 0.313,
        "clvSample": 7057,
        "winningDays": 24,
        "days": 45,
        "curve": [
          {
            "date": "2026-04-17",
            "units": 1.58
          },
          {
            "date": "2026-04-18",
            "units": 36.73
          },
          {
            "date": "2026-04-19",
            "units": 59.56
          },
          {
            "date": "2026-04-20",
            "units": 72.94
          },
          {
            "date": "2026-04-21",
            "units": 61.61
          },
          {
            "date": "2026-04-22",
            "units": 88.48
          },
          {
            "date": "2026-04-23",
            "units": 100.24
          },
          {
            "date": "2026-04-24",
            "units": 115.38
          },
          {
            "date": "2026-04-25",
            "units": 91.97
          },
          {
            "date": "2026-04-26",
            "units": 114.09
          },
          {
            "date": "2026-04-27",
            "units": 117.83
          },
          {
            "date": "2026-04-28",
            "units": 129.09
          },
          {
            "date": "2026-04-29",
            "units": 107.6
          },
          {
            "date": "2026-04-30",
            "units": 144.93
          },
          {
            "date": "2026-05-01",
            "units": 127.44
          },
          {
            "date": "2026-05-02",
            "units": 111.53
          },
          {
            "date": "2026-05-03",
            "units": 88.89
          },
          {
            "date": "2026-05-04",
            "units": 86.98
          },
          {
            "date": "2026-05-05",
            "units": 96.73
          },
          {
            "date": "2026-05-06",
            "units": 104.11
          },
          {
            "date": "2026-05-07",
            "units": 95.35
          },
          {
            "date": "2026-05-08",
            "units": 92.74
          },
          {
            "date": "2026-05-09",
            "units": 132.64
          },
          {
            "date": "2026-05-10",
            "units": 131.39
          },
          {
            "date": "2026-05-11",
            "units": 131.49
          },
          {
            "date": "2026-05-12",
            "units": 127.4
          },
          {
            "date": "2026-05-13",
            "units": 112.61
          },
          {
            "date": "2026-05-15",
            "units": 126.4
          },
          {
            "date": "2026-05-17",
            "units": 132.57
          },
          {
            "date": "2026-05-18",
            "units": 133.02
          },
          {
            "date": "2026-05-19",
            "units": 130.44
          },
          {
            "date": "2026-05-20",
            "units": 113.65
          },
          {
            "date": "2026-05-21",
            "units": 122.06
          },
          {
            "date": "2026-05-22",
            "units": 115.98
          },
          {
            "date": "2026-05-23",
            "units": 102.98
          },
          {
            "date": "2026-05-24",
            "units": 121.18
          },
          {
            "date": "2026-05-25",
            "units": 140.11
          },
          {
            "date": "2026-05-26",
            "units": 129.41
          },
          {
            "date": "2026-05-28",
            "units": 151.41
          },
          {
            "date": "2026-05-30",
            "units": 162.28
          },
          {
            "date": "2026-06-03",
            "units": 187.99
          },
          {
            "date": "2026-06-05",
            "units": 186.7
          },
          {
            "date": "2026-06-08",
            "units": 169.27
          },
          {
            "date": "2026-06-10",
            "units": 159.31
          },
          {
            "date": "2026-06-13",
            "units": 150.95
          }
        ]
      }
    }
  },
  "min30": {
    "label": "30 min before tip",
    "moment": "30 minutes before tip",
    "tiers": {
      "edge10": {
        "label": "10%+ edges",
        "minEv": 0.1,
        "picks": 892,
        "wins": 499,
        "losses": 391,
        "pushes": 2,
        "units": 78.72,
        "roi": 0.0883,
        "winRate": 0.5607,
        "avgEv": 0.154,
        "clv": null,
        "beatClose": null,
        "clvSample": 0,
        "winningDays": 27,
        "days": 45,
        "curve": [
          {
            "date": "2026-04-17",
            "units": 6.89
          },
          {
            "date": "2026-04-18",
            "units": 10.71
          },
          {
            "date": "2026-04-19",
            "units": 17.03
          },
          {
            "date": "2026-04-20",
            "units": 21.62
          },
          {
            "date": "2026-04-21",
            "units": 22.29
          },
          {
            "date": "2026-04-22",
            "units": 28.89
          },
          {
            "date": "2026-04-23",
            "units": 33.27
          },
          {
            "date": "2026-04-24",
            "units": 36.27
          },
          {
            "date": "2026-04-25",
            "units": 41.27
          },
          {
            "date": "2026-04-26",
            "units": 28.53
          },
          {
            "date": "2026-04-27",
            "units": 28.23
          },
          {
            "date": "2026-04-28",
            "units": 44.68
          },
          {
            "date": "2026-04-29",
            "units": 48.59
          },
          {
            "date": "2026-04-30",
            "units": 56.36
          },
          {
            "date": "2026-05-01",
            "units": 54.93
          },
          {
            "date": "2026-05-02",
            "units": 53.28
          },
          {
            "date": "2026-05-03",
            "units": 48.26
          },
          {
            "date": "2026-05-04",
            "units": 52.23
          },
          {
            "date": "2026-05-05",
            "units": 49.2
          },
          {
            "date": "2026-05-06",
            "units": 50.25
          },
          {
            "date": "2026-05-07",
            "units": 52.15
          },
          {
            "date": "2026-05-08",
            "units": 49.08
          },
          {
            "date": "2026-05-09",
            "units": 47.09
          },
          {
            "date": "2026-05-10",
            "units": 58.15
          },
          {
            "date": "2026-05-11",
            "units": 59.95
          },
          {
            "date": "2026-05-12",
            "units": 63.8
          },
          {
            "date": "2026-05-13",
            "units": 56.94
          },
          {
            "date": "2026-05-15",
            "units": 59.52
          },
          {
            "date": "2026-05-17",
            "units": 64.88
          },
          {
            "date": "2026-05-18",
            "units": 85.36
          },
          {
            "date": "2026-05-19",
            "units": 87.16
          },
          {
            "date": "2026-05-20",
            "units": 81.92
          },
          {
            "date": "2026-05-21",
            "units": 82.83
          },
          {
            "date": "2026-05-22",
            "units": 82.59
          },
          {
            "date": "2026-05-23",
            "units": 78.03
          },
          {
            "date": "2026-05-24",
            "units": 87.59
          },
          {
            "date": "2026-05-25",
            "units": 91.26
          },
          {
            "date": "2026-05-26",
            "units": 86.78
          },
          {
            "date": "2026-05-28",
            "units": 83.16
          },
          {
            "date": "2026-05-30",
            "units": 85.15
          },
          {
            "date": "2026-06-03",
            "units": 89.02
          },
          {
            "date": "2026-06-05",
            "units": 88.29
          },
          {
            "date": "2026-06-08",
            "units": 85.27
          },
          {
            "date": "2026-06-10",
            "units": 84.7
          },
          {
            "date": "2026-06-13",
            "units": 78.72
          }
        ]
      },
      "all": {
        "label": "All +EV",
        "minEv": 0,
        "picks": 7674,
        "wins": 4057,
        "losses": 3595,
        "pushes": 22,
        "units": 110.31,
        "roi": 0.0144,
        "winRate": 0.5302,
        "avgEv": 0.0519,
        "clv": null,
        "beatClose": null,
        "clvSample": 0,
        "winningDays": 23,
        "days": 45,
        "curve": [
          {
            "date": "2026-04-17",
            "units": -3.14
          },
          {
            "date": "2026-04-18",
            "units": 2.68
          },
          {
            "date": "2026-04-19",
            "units": -8.26
          },
          {
            "date": "2026-04-20",
            "units": 5.32
          },
          {
            "date": "2026-04-21",
            "units": -4.39
          },
          {
            "date": "2026-04-22",
            "units": 42.24
          },
          {
            "date": "2026-04-23",
            "units": 60.89
          },
          {
            "date": "2026-04-24",
            "units": 78.35
          },
          {
            "date": "2026-04-25",
            "units": 44.58
          },
          {
            "date": "2026-04-26",
            "units": 51.09
          },
          {
            "date": "2026-04-27",
            "units": 53.46
          },
          {
            "date": "2026-04-28",
            "units": 76.85
          },
          {
            "date": "2026-04-29",
            "units": 76.34
          },
          {
            "date": "2026-04-30",
            "units": 114
          },
          {
            "date": "2026-05-01",
            "units": 106.99
          },
          {
            "date": "2026-05-02",
            "units": 111.42
          },
          {
            "date": "2026-05-03",
            "units": 91.21
          },
          {
            "date": "2026-05-04",
            "units": 84.77
          },
          {
            "date": "2026-05-05",
            "units": 94.86
          },
          {
            "date": "2026-05-06",
            "units": 89.45
          },
          {
            "date": "2026-05-07",
            "units": 68.74
          },
          {
            "date": "2026-05-08",
            "units": 55.33
          },
          {
            "date": "2026-05-09",
            "units": 76.06
          },
          {
            "date": "2026-05-10",
            "units": 73.65
          },
          {
            "date": "2026-05-11",
            "units": 77.72
          },
          {
            "date": "2026-05-12",
            "units": 71.92
          },
          {
            "date": "2026-05-13",
            "units": 65.77
          },
          {
            "date": "2026-05-15",
            "units": 98.94
          },
          {
            "date": "2026-05-17",
            "units": 106.62
          },
          {
            "date": "2026-05-18",
            "units": 116
          },
          {
            "date": "2026-05-19",
            "units": 106.62
          },
          {
            "date": "2026-05-20",
            "units": 92.61
          },
          {
            "date": "2026-05-21",
            "units": 104.8
          },
          {
            "date": "2026-05-22",
            "units": 108.73
          },
          {
            "date": "2026-05-23",
            "units": 92.69
          },
          {
            "date": "2026-05-24",
            "units": 116.15
          },
          {
            "date": "2026-05-25",
            "units": 132.47
          },
          {
            "date": "2026-05-26",
            "units": 127.67
          },
          {
            "date": "2026-05-28",
            "units": 132.22
          },
          {
            "date": "2026-05-30",
            "units": 135.41
          },
          {
            "date": "2026-06-03",
            "units": 156.24
          },
          {
            "date": "2026-06-05",
            "units": 154.15
          },
          {
            "date": "2026-06-08",
            "units": 137.18
          },
          {
            "date": "2026-06-10",
            "units": 135.36
          },
          {
            "date": "2026-06-13",
            "units": 110.31
          }
        ]
      }
    }
  }
};

export const NBA_RESULTS = {
  label: "2026 NBA Playoffs",
  startDate: "2026-04-17",
  endDate: "2026-06-13",
  snapshots: SNAPSHOTS,
  tiers: SNAPSHOTS.lpu.tiers,
};
